import _ from 'lodash';

export default months => {
	const day = _.flatten(months.map(({ days }) => days)).find(({ timeSlots }) => timeSlots && timeSlots.length);
	return day && day.date;
};
